// components/LeadForm.jsx
import { useState } from 'react';
import { INITIAL_FORM_VALUE, DEFAULT_IMAGES } from '../constants';

export const LeadForm = ({ widgetDetails, onSubmit, disabled }) => {
  const [formData, setFormData] = useState(INITIAL_FORM_VALUE);
  const { name, email, phone_number } = formData;

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const isFormValid = name && email && phone_number;

  return (
    <div className='user-box-wrapper position-relative' style={{ background: widgetDetails?.color }}>
      <div className='user-box'>
        <div className='user-box-img p-0' style={{ border: `1.5px solid ${widgetDetails?.color}` }}>
          <div
            className='widget-user-icon'
            style={{
              width: '40px',
              height: '40px',
              minWidth: '40px',
              minHeight: '40px',
            }}
          >
            <img src={widgetDetails?.chatbot_avtar || DEFAULT_IMAGES.SIDEBAR_BOX_IMG} alt='chatbot-icon' />
          </div>
        </div>

        <form id='form' onSubmit={handleSubmit}>
          <div className='mb-3'>
            <label className='outfit-medium' style={{ color: widgetDetails?.agent_bubble_text_color }}>
              Name
            </label>
            <input
              type='text'
              className='form-control'
              name='name'
              id='name'
              required
              autoComplete='off'
              placeholder='Enter your name'
              value={name}
              onChange={(e) => handleChange('name', e.target.value)}
              style={{ color: '#000000' }}
            />
          </div>

          <div className='mb-3'>
            <label className='outfit-medium' style={{ color: widgetDetails?.agent_bubble_text_color }}>
              Email
            </label>
            <input
              type='email'
              className='form-control'
              name='email'
              required
              autoComplete='off'
              placeholder='Enter your email'
              pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'
              value={email}
              onChange={(e) => handleChange('email', e.target.value)}
              style={{ color: '#000000' }}
            />
          </div>

          <div className='mb-4'>
            <label className='outfit-medium' style={{ color: widgetDetails?.agent_bubble_text_color }}>
              Phone
            </label>
            <input
              type='number'
              className='form-control'
              name='phone_number'
              required
              autoComplete='off'
              placeholder='Enter your number'
              maxLength='10'
              value={phone_number}
              onChange={(e) => {
                if (e.target.value.length <= 10) {
                  handleChange('phone_number', e.target.value);
                }
              }}
              style={{ color: '#000000' }}
            />
          </div>

          <input
            id='submit'
            type='submit'
            disabled={!isFormValid || disabled}
            style={{
              opacity: !isFormValid ? 0.3 : 1,
              cursor: !isFormValid ? 'not-allowed' : 'pointer',
              background: widgetDetails?.client_bubble_color,
              color: widgetDetails?.bubble_text_color,
            }}
          />
        </form>
      </div>
    </div>
  );
};
